export enum DeviceTypeEnum {
    None,
    AQ,
    MQ,
    Mixed,
    FuelCell,
    LPCam = 5,
    DomeCam = 6,
    BarrierLaneSwitch = 7,
    BarrierBar = 8,
    BarrierSwing = 9,
    Energy = 10,
    Weather = 11
}

export function getDeviceTypeName(type: DeviceTypeEnum): string {
    switch (type) {
        case DeviceTypeEnum.AQ:
            return 'AQ';
        case DeviceTypeEnum.MQ:
            return 'MQ';
        case DeviceTypeEnum.Mixed:
            return 'AQ+MQ';
        case DeviceTypeEnum.FuelCell:
            return 'FuelCell';
        case DeviceTypeEnum.LPCam:
            return 'LPCam';
        case DeviceTypeEnum.DomeCam:
            return 'DomeCam';
        case DeviceTypeEnum.BarrierLaneSwitch:
            return 'BarrierLaneSwitch';
        case DeviceTypeEnum.BarrierBar:
            return 'BarrierBar';
        case DeviceTypeEnum.BarrierSwing:
            return 'BarrierBar';
        default:
            return 'Unknown';
    }
}